MOVE.MORTGAGE.RATES.PAGINATION = (function () {

  var getPage = function (rates, pageNumber, perPage) {
    var page           = pageNumber || 1;
    var offset         = (page - 1) * perPage;
    var paginatedItems = _.rest(rates, offset).slice(0, perPage);

    return {
      page: page,
      items: paginatedItems,
      perPage: perPage,
      total: rates.length,
      totalPages: Math.ceil(rates.length / (perPage || 1))
    };
  };

  MOVE.MORTGAGE.RATES.PAGINATION = {
    getPage: getPage
  };

  return MOVE.MORTGAGE.RATES.PAGINATION;

})();



// WEBPACK FOOTER //
// ./mortgage/rates/pagination.js